<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ 'title' | i18n }}</h2>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="apply()" (keydown.enter)="apply()" class="settings-form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'name' | i18n }}</mat-label>
        <input
          matInput
          formControlName="name"
          [placeholder]="'name_placeholder' | i18n"
        />
        @if(form.controls.name.hasError('duplicateName')) {
          <mat-error>
            {{'name_duplicate' | i18n}}
          </mat-error>
        }
      </mat-form-field>

      <div>
        <input
          type="file"
          accept=".json"
          hidden
          #fileInput
          (change)="onFileSelected($event)"
        />
        <button mat-stroked-button type="button" (click)="fileInput.click()">
          <mat-icon>upload_file</mat-icon>
          {{ 'import_btn' | i18n}}
        </button>

        <div style="margin-top: 8px;">
          @if (importedFileName) {
            <div style="display: flex; align-items: center;">
                <mat-icon>check_circle</mat-icon>
                {{ importedFileName }}
            </div>
          }
          @if (importIssues.length) {
            @for (issue of importIssues; track issue) {
              <div class="import-issue">
                <mat-icon>warning</mat-icon>
                <span>{{ issue | i18n }}</span>
              </div>
            }
          }
          @if (importError) {
            <mat-error>{{ importError }}</mat-error>
          }
        </div>

      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-button (click)="cancel()">
      {{ 'cancel' | i18n }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      (click)="apply()"
      [disabled]="form.invalid"
    >
      {{ 'apply' | i18n }}
    </button>
  </mat-dialog-actions>
</ng-container>